import * as React from "react";
const cardone = (props) => (
  <svg
    width={260}
    height={260}
    viewBox="0 0 260 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M74.8431 83.5714C84.694 83.5714 94.1414 79.6581 101.107 72.6925C108.073 65.7268 111.986 56.2794 111.986 46.4285C111.986 36.5776 108.073 27.1302 101.107 20.1645C94.1414 13.1989 84.694 9.28564 74.8431 9.28564C64.9922 9.28564 55.5447 13.1989 48.5791 20.1645C41.6135 27.1302 37.7002 36.5776 37.7002 46.4285C37.7002 56.2794 41.6135 65.7268 48.5791 72.6925C55.5447 79.6581 64.9922 83.5714 74.8431 83.5714Z"
      stroke="#313F78"
      strokeWidth={13.57}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.154 195.446L99.2456 250.714H50.6442L41.3585 176.428H9.82422V148.571C9.8267 132.357 15.8889 116.73 26.821 104.756C37.7531 92.7813 52.7657 85.3252 68.9125 83.8506C85.0592 82.3759 101.174 86.9892 114.094 96.785C127.015 106.581 135.808 120.852 138.747 136.797M170.411 168.777V156.706C170.411 151.78 172.368 147.056 175.851 143.574C179.334 140.091 184.057 138.134 188.983 138.134H196.634C201.56 138.134 206.283 140.091 209.766 143.574C213.249 147.056 215.206 151.78 215.206 156.706V168.777M135.479 185.157C135.479 176.113 142.814 168.777 151.859 168.777H233.796C242.84 168.777 250.176 176.113 250.176 185.176V234.334C250.181 236.487 249.76 238.619 248.939 240.608C248.117 242.598 246.911 244.405 245.389 245.927C243.867 247.449 242.059 248.656 240.07 249.477C238.08 250.299 235.948 250.719 233.796 250.714H151.859C149.706 250.719 147.574 250.299 145.584 249.477C143.595 248.656 141.787 247.449 140.265 245.927C138.743 244.405 137.537 242.598 136.715 240.608C135.894 238.619 135.474 236.487 135.479 234.334V185.157Z"
      stroke="#313F78"
      strokeWidth={13.57}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default cardone;
